<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <header-page titleText="Financeiro" titleIcon="fal fa-usd-square" />

      <!-- <v-container>
        <v-row>
          <v-col>
            <v-btn
              text
              rounded
              large
              class="px-12"
              @click="changeSelectedPaymentMethod(paymentMethods.BankBillet)"
            >
              Boletos
            </v-btn>
            <v-btn
              text
              rounded
              large
              class="px-12"
              @click="changeSelectedPaymentMethod(paymentMethods.BankTransfer)"
            >
              Transferências
            </v-btn>
          </v-col>
        </v-row>
      </v-container> -->

      <!-- <v-container pa-6>
        <v-row justify="space-between">
          <v-col cols="auto" v-show="!loading"> </v-col>
        </v-row>
      </v-container> -->

      <!-- Search Results ########################################### -->
      <search-result
        inset
        :totalResults="totalNumberOfDonations"
        v-model="searchTerms"
        :showAddButton="false"
        :showFilterButton="true"
        :showExcelButton="true"
        @filterButtonClick="showFilters"
        @excelButtonClick="download"
      />
      <!-- Page Body ########################################### -->
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-data-table
              class="br-4 no-wrap table-traduction mb-2"
              :headers="headers"
              :items="financeDetails"
              item-key="id"
              no-data-text="Nenhum resultado encontrado"
              :loading="loading"
            >
              <template v-slot:item.dueDate="{ item }">
                {{ formatterHelper.formatDate(item.dueDate) }}
              </template>
              <template v-slot:item.paymentDate="{ item }">
                {{ formatterHelper.formatDate(item.paymentDate) }}
              </template>
              <template v-slot:item.value="{ item }">
                {{ formatterHelper.formatMoney(item.value) }}
              </template>
              <template v-slot:item.donorDocument="{ item }">
                {{ formatterHelper.formatDocument(item.donorDocument) }}
              </template>
              <template v-slot:item.status="{ item }">
                {{ formatterHelper.formatDonationStatus(item.status) }}
              </template>
              <template v-slot:item.paymentMethod="{ item }">
                {{ formatterHelper.formatPaymentMethod(item.paymentMethod) }}
              </template>
              <template v-slot:item.isDARF="{ item }">
                {{ item.paymentMethod == paymentMethods.BankTransfer ? formatterHelper.formatIsDARF(item.isDARF) : '-' }}
              </template>
              <template v-slot:item.donationDate="{ item }">
                {{ formatterHelper.formatDate(item.donationDate) }}
              </template>
              <template v-slot:item.anonymous="{ item }">
                {{ item.anonymous ? "Sim" : "Não" }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip
                  top
                  v-if="item.paymentMethod == paymentMethods.BankTransfer"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon class="mr-2" small v-on="on">fal fa-comment</v-icon>
                  </template>
                  <span>
                    {{ item.transferObservation }}
                  </span>
                </v-tooltip>
                <v-icon
                  title="Download comprovante"
                  small
                  class="mr-2"
                  v-if="item.paymentMethod == paymentMethods.BankTransfer"
                  @click="downloadAttachment(item)"
                >
                  fal fa-download
                </v-icon>
                <v-icon
                  title="Confirmar pagamento"
                  small
                  class="mr-2"
                  @click="shouldConfirmPayment(item)"
                  v-if="item.status == donationStatus.Pending"
                >
                  fal fa-check
                </v-icon>
                <v-icon
                  title="Cancelar pagamento"
                  small
                  @click="shouldCancelPayment(item)"
                  v-if="item.status == donationStatus.Pending || (isBenefactor && item.status == donationStatus.Paid)"
                >
                  fal fa-times
                </v-icon>
                <v-icon
                  title="Voltar para pendente"
                  small
                  @click="shouldReturnPaymentToPending(item)"
                  v-if="item.status == donationStatus.Paid && !item.hasReceipt"
                >
                  fal fa-exchange
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog
        v-model="showReturnPaymentToPendingConfirmation"
        persistent
        max-width="490"
      >
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7 red--text">Voltar doação para pendente</h5>
          </v-card-title>
          <v-card-text
            >Você tem certeza que deseja voltar a doação para o status
            pendente?</v-card-text
          >
          <v-divider></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-btn
              color="gray"
              rounded
              large
              depressed
              class="px-12"
              @click="showReturnPaymentToPendingConfirmation = false"
              :loading="returningPaymentToPending"
              >Não</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              rounded
              large
              depressed
              class="px-12"
              @click="returnPaymentToPending()"
              :loading="returningPaymentToPending"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showCancelPaymentConfirmation"
        persistent
        max-width="490"
      >
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7 red--text">Cancelar doação</h5>
          </v-card-title>
          <v-card-text>{{ cancelMessage }}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-btn
              color="gray"
              rounded
              large
              depressed
              class="px-12"
              @click="showCancelPaymentConfirmation = false"
              :loading="cancelingPayment"
              >Não</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              rounded
              large
              depressed
              class="px-12"
              @click="cancelPayment()"
              :loading="cancelingPayment"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showConfirmPaymentModal" persistent max-width="490">
        <v-card>
          <v-card-title>
            <h5 class="pt-5 pb-7 red--text">Confirmar doação</h5>
          </v-card-title>
          <v-card-text>
            <v-form v-model="confirmationInfoValid">
              <v-container fluid pa-0>
                <v-row>
                  <v-col cols="12">
                    <InputDate
                      v-model="paymentDate"
                      label="Data do pagamento"
                      :rules="[validatePaymentDate]"
                      required
                      :disabled="confirmingPayment"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      ref="donationValueTextField"
                      v-model.lazy="donationValue"
                      v-money="money"
                      label="Valor da Doação"
                      outlined
                      hide-details="auto"
                      required
                      :rules="[validateDonationValue]"
                      :disabled="confirmingPayment"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-6 py-5">
            <v-btn
              color="gray"
              rounded
              large
              depressed
              class="px-12"
              @click="showConfirmPaymentModal = false"
              :loading="confirmingPayment"
              >Cancelar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              rounded
              large
              depressed
              class="px-12"
              @click="confirmPayment()"
              :disabled="!confirmationInfoValid"
              :loading="confirmingPayment"
              >Confirmar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="showFilterDialog" max-width="490">
      <v-card>
        <v-card-title>
          <h5 class="pt-5 pb-7">Filtrar</h5>
          <v-spacer></v-spacer>
          <v-btn color="secondary" icon @click="closeFilterDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <InputDate
                v-model="startDate"
                label="De"
                :maxDate="startDateMax"
                :disabled="false"
              />
            </v-col>
            <v-col cols="6">
              <InputDate
                v-model="endDate"
                label="Até"
                :minDate="endDateMin"
                :maxDate="endDateMax"
                :disabled="false"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedStatus"
                :items="statusList"
                label="Status"
                outlined
                hide-details="auto"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="selectedPaymentMethod"
                :items="paymentMethodsList"
                label="Forma de pgto"
                outlined
                hide-details="auto"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                ref="startValueTextField"
                v-model.lazy="startValue"
                v-money="money"
                label="De"
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                ref="endValueTextField"
                v-model.lazy="endValue"
                v-money="money"
                label="Até"
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-mask="['###.###.###-##', '##.###.###/####-##']"
                v-model="donorDocument"
                label="CPF/CNPJ Doador"
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="donorName"
                label="Nome Doador"
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="agentName"
                label="Nome Agente"
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="billetNumber"
                label="Boleto"
                outlined
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="lg"></v-divider>
        <v-card-actions class="px-6 py-5">
          <v-btn
            rounded
            outlined
            large
            depressed
            class="px-12 gray"
            @click="clearFilters()"
            >Limpar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            rounded
            large
            depressed
            class="px-12"
            @click="applyFilters()"
            >Filtrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NavBar from "@/components/NavBar";
import HeaderPage from "@/components/HeaderPage";
import SearchResult from "@/components/SearchResult";
import FinanceService from "@/scripts/services/finance.service";
import Routes from "@/router/names.js";
import FormatterHelper from "@/scripts/helpers/formatter.helper";
import PaymentMethods from "@/scripts/enums/paymentMethods.enum";
import DonationStatus from "@/scripts/enums/donationStatus.enum";
import CommonHelper from "@/scripts/helpers/common.helper";
import XLSX from "xlsx";

export default {
  name: "Finance",
  components: {
    NavBar,
    HeaderPage,
    SearchResult
  },
  data: () => ({
    routes: Routes,
    paymentMethods: PaymentMethods,
    selectedPaymentMethod: null,
    financeService: new FinanceService(),
    loading: false,
    financeDetails: [],
    searchTerms: [],
    formatterHelper: FormatterHelper,
    donationToPerformAction: null,
    showReturnPaymentToPendingConfirmation: false,
    showCancelPaymentConfirmation: false,
    showConfirmPaymentModal: false,
    returningPaymentToPending: false,
    cancelingPayment: false,
    confirmingPayment: false,
    donationStatus: DonationStatus,
    paymentDate: null,
    confirmationInfoValid: false,
    donationValue: 0,
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "",
      suffix: "",
      precision: 2
    },
    showFilterDialog: false,
    paymentMethodsList: [
      {
        id: null,
        name: "Todos"
      },
      {
        id: PaymentMethods.BankBillet,
        name: FormatterHelper.formatPaymentMethod(PaymentMethods.BankBillet)
      },
      {
        id: PaymentMethods.BankTransfer,
        name: FormatterHelper.formatPaymentMethod(PaymentMethods.BankTransfer)
      }
    ],
    statusList: [
      {
        id: null,
        name: "Todos"
      },
      {
        id: DonationStatus.Pending,
        name: FormatterHelper.formatDonationStatus(DonationStatus.Pending)
      },
      {
        id: DonationStatus.Paid,
        name: FormatterHelper.formatDonationStatus(DonationStatus.Paid)
      },
      {
        id: DonationStatus.Cancelled,
        name: FormatterHelper.formatDonationStatus(DonationStatus.Cancelled)
      },
      {
        id: DonationStatus.Expired,
        name: FormatterHelper.formatDonationStatus(DonationStatus.Expired)
      }
    ],
    selectedStatus: DonationStatus.Pending,
    startDate: null,
    endDate: null,
    startValue: 0,
    endValue: 0,
    donorDocument: null,
    donorName: null,
    agentName: null,
    billetNumber: null
  }),
  mounted() {
    this.loadFinanceDetails();
  },
  computed: {
    ...mapGetters("userModule", ["loggedEntityId","isBenefactor"]),
    cancelMessage() {
      if (
        // this.selectedPaymentMethod == PaymentMethods.BankBillet &&
        this.donationToPerformAction &&
        this.donationToPerformAction.paymentMethod == PaymentMethods.BankBillet
      )
        return `Você tem certeza de que gostaria de cancelar o boleto numero ${
          this.donationToPerformAction.billetNumber
        }, do doador ${
          this.donationToPerformAction.donorName
        } no valor de ${FormatterHelper.formatMoney(
          this.donationToPerformAction.value
        )}? O cancelamento será irreversível.`;
      else return "Deseja realmente cancelar essa doação?";
    },
    startDateMax() {
      if (this.endDate) return this.endDate;
      return new Date();
    },
    endDateMin() {
      if (this.startDate) return this.startDate;
      return null;
    },
    endDateMax() {
      return new Date();
    },
    totalNumberOfDonations() {
      if (this.financeDetails) return this.financeDetails.length;
      return 0;
    },
    headers() {
      return [
        {
          text: "Doação",
          value: "donationId",
          download: true
        },
        {
          text: "Data de Pagamento",
          value: "paymentDate",
          formatter: this.formatDate,
          download: true
        },
        {
          text: "Número do Boleto",
          value: "billetNumber",
          download: true
        },
        {
          text: "Data de Vencimento",
          value: "dueDate",
          formatter: this.formatDate,
          download: true
        },
        {
          text: "Valor",
          value: "value",
          formatter: FormatterHelper.formatMoney,
          download: true
        },
        {
          text: "CPF/CNPJ Doador",
          value: "donorDocument",
          formatter: this.formatDocument,
          download: true
        },
        {
          text: "Instituição",
          value: "institutionName",
          download: true
        },
        {
          text: "Nome Doador",
          value: "donorName",
          download: true
        },
        {
          text: "Status",
          value: "status",
          formatter: FormatterHelper.formatDonationStatus,
          download: true
        },
        {
          text: "Forma de pgto",
          value: "paymentMethod",
          formatter: FormatterHelper.formatPaymentMethod,
          download: true
        },
        {
          text: "Tipo",
          value: "isDARF",
          formatter: FormatterHelper.formatIsDARF,
          download: true
        },
        {
          text: "Data de Emissão",
          value: "donationDate",
          formatter: this.formatDate,
          download: true
        },
        {
          text: "Nome Agente",
          value: "agentName",
          download: true
        },
        {
          text: "Anônimo",
          value: "anonymous",
          download: true
        },
        {
          text: "Ações",
          value: "actions",
          download: false
        }
      ];
    }
  },
  methods: {
    ...mapActions(["setSelectedSecretary"]),
    formatDocument(document) {
      return FormatterHelper.formatDocument(document);
    },
    formatDate(date) {
      return FormatterHelper.formatDate(date);
    },
    downloadAttachment(item) {
      window.open(item.attachmentUrl);
    },
    getFilters() {
      let filters = {
        paymentMethod: this.selectedPaymentMethod,
        status: this.selectedStatus,
        donorDocument: this.donorDocument,
        donorName: this.donorName,
        agentName: this.agentName,
        paymentDateStart: this.startDate,
        paymentDateEnd: this.endDate,
        entityId: parseInt(this.loggedEntityId)
      };
      const sValue = this.getValueNumber(this.startValue);
      const eValue = this.getValueNumber(this.endValue);
      if (sValue > 0) {
        filters.valueStart = sValue;
      }
      if (eValue > 0) {
        filters.valueEnd = eValue;
      }
      // if (this.selectedPaymentMethod == PaymentMethods.BankBillet)
        filters.billetNumber = this.billetNumber;
      return filters;
    },
    // changeSelectedPaymentMethod(paymentMethod) {
    //   if (paymentMethod != this.selectedPaymentMethod) {
    //     this.selectedPaymentMethod = paymentMethod;
    //     this.loadFinanceDetails();
    //   }
    // },
    loadFinanceDetails() {
      if (this.loading) return;
      this.financeDetails = [];
      this.loading = true;
      this.financeService
        .getFinanceDetails(this.getFilters())
        .then(this.loadFinanceDetailsCallBack)
        .finally(() => (this.loading = false));
    },
    loadFinanceDetailsCallBack(data) {
      this.financeDetails = data;
      this.loadingList = false;
    },
    shouldConfirmPayment(donation) {
      this.paymentDate = null;
      if (donation.paymentDate)
        this.paymentDate = new Date(donation.paymentDate);
      else this.paymentDate = new Date(donation.dueDate);
      this.showConfirmPaymentModal = true;
      this.donationToPerformAction = donation;
      this.$nextTick(() => {
        this.changeValue(donation.value, "donationValueTextField");
        this.donationValue = donation.value;
      });
    },
    confirmPayment() {
      this.confirmingPayment = true;
      this.financeService
        .confirmPayment({
          donationId: this.donationToPerformAction.donationId,
          paymentDate: this.paymentDate,
          paymentValue: this.getValueNumber(this.donationValue)
        })
        .then(() => this.loadFinanceDetails())
        .finally(() => {
          this.showConfirmPaymentModal = false;
          this.confirmingPayment = false;
        });
    },
    shouldReturnPaymentToPending(donation) {
      this.donationToPerformAction = donation;
      this.showReturnPaymentToPendingConfirmation = true;
    },
    returnPaymentToPending() {
      this.returningPaymentToPending = true;
      this.financeService
        .returnDonationToPending(this.donationToPerformAction.donationId)
        .then(() => this.loadFinanceDetails())
        .finally(() => {
          this.showReturnPaymentToPendingConfirmation = false;
          this.returningPaymentToPending = false;
        });
    },
    shouldCancelPayment(donation) {
      this.donationToPerformAction = donation;
      this.showCancelPaymentConfirmation = true;
    },
    cancelPayment() {
      this.cancelingPayment = true;
      this.financeService
        .cancelPayment(this.donationToPerformAction.donationId)
        .then(() => this.loadFinanceDetails())
        .finally(() => {
          this.showCancelPaymentConfirmation = false;
          this.cancelingPayment = false;
        });
    },
    validateDonationValue() {
      if (this.getValueNumber(this.donationValue) > 0) return true;
      return "O valor deve ser maior do que zero.";
    },
    changeValue(newValue, field) {
      this.$refs[field].$el.getElementsByTagName("input")[0].value = newValue;
    },
    getValueNumber(value) {
      if (value instanceof String || typeof value === "string")
        return parseInt(value.replace(/\D/g, ""));
      else if (value instanceof Number) return value;
      return 0;
    },
    validatePaymentDate() {
      if (this.paymentDate) {
        return true;
      }
      return "Selecione a data do pagamento.";
    },
    showFilters() {
      this.showFilterDialog = true;
    },
    closeFilterDialog() {
      this.showFilterDialog = false;
    },
    clearFilters() {
      this.selectedStatus = null;
      this.startDate = null;
      this.endDate = null;
      this.changeValue(0, "startValueTextField");
      this.startValue = 0;
      this.changeValue(0, "endValueTextField");
      this.endValue = 0;
      this.donorDocument = "";
      this.donorName = "";
      this.agentName = "";
      this.billetNumber = "";
      this.applyFilters();
    },
    applyFilters() {
      this.closeFilterDialog();
      this.loadFinanceDetails();
    },
    download() {
      if (this.financeDetails.length == 0) {
        CommonHelper.swal("", "Nenhum dado disponível para download.", "error");
        return;
      }
      var blob = new Blob([this.s2ab()], {
        type: "application/octet-stream"
      });
      this.save(blob, "xlsx");
    },
    getWSData() {
      let wsData = [];
      let text = [];
      wsData.push(text);
      let i, j;
      for (i = 0; i < this.headers.length; i++) {
        if (this.headers[i].download) text.push(this.headers[i].text);
      }
      text = [];
      wsData.push(text);

      for (i = 0; i < this.financeDetails.length; i++) {
        for (j = 0; j < this.headers.length; j++) {
          if (this.headers[j].download) {
            let valueToAddToLine = this.financeDetails[i][
              this.headers[j].value
            ];
            if (this.headers[j].formatter) {
              if(this.headers[j].text != 'Tipo' || this.financeDetails[i].paymentMethod == PaymentMethods.BankTransfer)
                valueToAddToLine = this.headers[j].formatter(valueToAddToLine);
              else
                valueToAddToLine = '-';
            }
            text.push(valueToAddToLine);
          }
        }
        text = [];
        wsData.push(text);
      }
      return wsData;
    },
    generateExcel() {
      if (this.financeDetails.length == 0) {
        CommonHelper.swal("", "Nenhum dado disponível para download.", "error");
        return;
      }
      var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Dados",
        Subject: "Dados",
        Author: "Benfeitores",
        CreatedDate: new Date()
      };
      wb.SheetNames.push("Dados");
      var ws_data = this.getWSData();
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Dados"] = ws;
      return XLSX.write(wb, { bookType: "xlsx", type: "binary" });
    },
    s2ab() {
      let s = this.generateExcel();
      var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      var view = new Uint8Array(buf); //create uint8array as viewer
      for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
      return buf;
    },
    save(blob, type) {
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, "Financeiro.csv");
      } else {
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = "Financeiro." + type;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    }
  }
};
</script>